<template>
  <div class="modal_wrap system ic_commonModal" :class="{ on: show }">
    <div class="modal_inner">
      <div class="modal commu_modal">
        <div class="modal_head">
          <h1 class="h1">신고하기</h1>
        </div>
        <div class="modal_con">
          <div class="form_wrap">
            <div class="check_table">
              <label v-for="(item, index) in items" :key="index"
                ><input
                  type="radio"
                  name="sort"
                  :value="item"
                  v-model="selectedValue"
                /><span>{{ item.label }}</span></label
              >
            </div>
            <textarea
              ref="textarea"
              placeholder="신고 사유를 입력해주세요"
              maxlength="100"
              v-model.trim="text"
              v-if="selectedValue && selectedValue.value === 'ETC'"
            />
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn" @click="close">닫기</button>
            <button class="btn2" @click="confirm">
              신고하기
            </button>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="made_toast_layer_common" style="top:55%;" v-if="isViewToast">
        <div class="toast_msg">{{ errorMessage }}</div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'componment-community-report-modal',
  description: '커뮤니티 > 신고 팝업',
  props: {
    show: Boolean,
    value: Object,
  },
  data(props) {
    return {
      items: [
        { label: '불쾌감 및 분란 유발', value: '' },
        { label: '상업적 목적의 홍보 및 도배', value: '' },
        { label: '음란성 및 청소년에게 부적절한 내용', value: '' },
        { label: '기타', value: 'ETC' },
      ],
      selectedValue: props.value,
      text: '',
      isViewToast: false,
      errorMessage: '',
    };
  },
  methods: {
    close() {
      this.selectedValue = this.value;
      this.$emit('close');
    },
    confirm() {
      if (!this.selectedValue) {
        this.errorMessage = '신고사유를 선택해주세요';
        this.toastView();
        return;
      }
      let reason = this.selectedValue.label;
      if (this.selectedValue.value === 'ETC') {
        if (!this.text) {
          this.errorMessage = '신고사유를 입력해주세요';
          this.$refs.textarea.focus();
          this.toastView();
          return;
        }
        reason = this.text;
      }
      this.$emit('close', reason);
    },
    toastView() {
      this.isViewToast = true;
      setTimeout(() => {
        this.isViewToast = false;
      }, 2000);
    },
  },
};
</script>
